import React, { useEffect,useState } from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal} from 'react-bootstrap'
import '../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import { billCollectionApi, prevCollectionhistoryApi, searchtableApi } from '../../../utils/AdminDashApi/Bill/BillApi'
import { optionsPeriod, optionsbilltype, optionsrcvtype, optionsremark } from '../../Helper'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { HighlightRowText } from '../../../pages/adminDashboard/Bill/subComponents/HighlightRowText'
const BillUpdateComp = () => {

    const [searchkey,setsearchkey] = useState("")

    const [id,setid] = useState("")
    const [billnumber,setbillnumber] = useState("")
    const [type,settype] = useState("")
    const [rcvtype,setrcvtype] = useState("")
    const [rcvtype2,setrcvtype2] = useState("")
    const [billamount,setbillamount] = useState("")
    const [billamount2,setbillamount2] = useState("")
    const [rcvamount,setrcvamount] = useState("")
    const [rcvamount2,setrcvamount2] = useState("")
    const [discount,setdiscount] = useState("")
    const [discount2,setdiscount2] = useState("")    
    const [cperiod,setcperiod] = useState("")
    const [cperiod2,setcperiod2] = useState("")
    const [remark,setremark] = useState("")
    const [remark2,setremark2] = useState("")
    const [stuname,setstuname] = useState("")
    const [session,setsession] = useState("")
    const [shift,setshift] = useState("")
    const [myclass,setclass] = useState("")
    const [period,setperiod] = useState("")
    const [section,setsection] = useState("")
    const [period1,setperiod1] = useState("")

    const [labelbillnum,setlabelbillnum] = useState("")
    const [labelid,setlabelid] = useState("")
    const [labelstuname,setlabelstuname] = useState("")
    const [labelsession,setlabelsession] = useState("")
    const [labelshift,setlabelshift] = useState("")
    const [labelclass,setlabelclass] = useState("")
    const [labelperiod,setlabelperiod] = useState("")
    const [labelsection,setlabelsection] = useState("")
    const [labelrcvtype1,setlabelrcvtype1] = useState("")
    const [labelbillamount1,setlabelbillamount1] = useState("")
    const [labelrcvamount1,setlabelrcvamount1] = useState("")
    const [labeldiscount1,setlabeldiscount1] = useState("")
    const [labelperiod1,setlabelperiod1] = useState("")
    const [labelremark1,setlabelremark1] = useState("")

    const [borderbillnumber,setborderbillnumber] = useState("")
    const [borderid,setborderid] = useState("")
    const [borderstuname,setborderstuname] = useState("")
    const [bordersession,setbordersession] = useState("")
    const [bordershift,setbordershift] = useState("")
    const [borderclass,setborderclass] = useState("")
    const [borderperiod,setborderperiod] = useState("")
    const [bordersection,setbordersection] = useState("")
    const [borderrcvtype1,setborderrcvtype1] = useState("")
    const [borderbillamount1,setborderbillamount1] = useState("")
    const [borderrcvamount1,setborderrcvamount1] = useState("")
    const [borderdiscount1,setborderdiscount1] = useState(false)
    const [borderperiod1,setborderperiod1] = useState("")
    const [borderremark1,setborderremark1] = useState("")


    const drpfuncperiod1=(myval,myid)=>{
        setperiod1(myid)
    }
    const drpfuncperiod=(myval,myid)=>{
        setcperiod(myid)
    }
    const drpfuncperiod2=(myval,myid)=>{
        setcperiod2(myid)
    }
    const drpfuncremark=(myval,myid)=>{
        setremark(myid)
    }
    const drpfuncremark2=(myval,myid)=>{
        setremark2(myid)
    }
    const drpfuncrcvtype=(myval,myid)=>{
        setrcvtype(myid)
    }
    const drpfuncrcvtype2=(myval,myid)=>{
        setrcvtype2(myid)
    }

    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])

      const [searchpopulatedata,setsearchpopulatedata] = useState({
        headerid:"",
        id:""
    })
    const handleRowClick=(myitem)=>{
        console.log(myitem.headerid)
        setsearchpopulatedata({...searchpopulatedata,["headerid"]:myitem.headerid})
        console.log("ami clicked")
        setsearchkey("")

    }
    
    const handleSave=()=>{


        if(!billnumber && billnumber==""){
            setborderbillnumber(true)
            setlabelbillnum("bill number required")
        }
        else{
            setborderbillnumber(false)
            setlabelbillnum("")
        }
        if(!id && id==""){
            setborderid(true)
            setlabelid("ID required")
        }
        else{
            setborderid(false)
            setlabelid("")
        }
        if(!stuname && stuname==""){
            setborderstuname(true)
            setlabelstuname("Student name required")
        }
        else{
            setborderstuname(false)
            setlabelstuname("")
        }
        if(!session && session==""){
            setbordersession(true)
            setlabelsession("Session required")
        }
        else{
            setbordersession(false)
            setlabelsession("")
        }
        if(!shift && shift==""){
            setbordershift(true)
            setlabelshift("Shift required")
        }
        else{
            setbordershift(false)
            setlabelshift("")
        }
        if(!myclass && myclass==""){
            setborderclass(true)
            setlabelclass("Class required")
        }
        else{
            setborderclass(false)
            setlabelclass("")
        }
        if(!period && period==""){
            setborderperiod(true)
            setlabelperiod("Period required")
        }
        else{
            setborderperiod(false)
            setlabelperiod("")
        }
        if(!section && section==""){
            setbordersection(true)
            setlabelsection("Period required")
        }
        else{
            setbordersection(false)
            setlabelsection("")
        }
        if(!rcvtype && rcvtype==""){
            setlabelrcvtype1("Rcv type required")
            setborderrcvtype1("err")
        }
        else{
            setlabelrcvtype1("")
            setborderrcvtype1("")

        }
        if(!billamount && billamount==""){
            setlabelbillamount1("Bill Amount required")
            setborderbillamount1("err")
        }
        else{
            setlabelbillamount1("")
            setborderbillamount1("")

        }
        if(!rcvamount && rcvamount==""){
            setlabelrcvamount1("Rcv Amount required")
            setborderrcvamount1("err")
        }
        else{
            setlabelrcvamount1("")
            setborderrcvamount1("")

        }
        if(!discount && discount==""){
            setlabeldiscount1("Disount Required")
            setborderdiscount1(true)
        }
        else{
            setlabeldiscount1("D")
            setborderdiscount1(false)

        }
        if(!period1 && period1==""){
            setlabelperiod1("Disount Required")
            setborderperiod1("err")
        }
        else{
            setlabelperiod1("")
            setborderperiod1("")

        }
        if(!remark && remark==""){
            setlabelremark1("Disount Required")
            setborderremark1("err")
        }
        else{
            setlabelremark1("")
            setborderremark1("")

        }

        if(
            billnumber.length!==0 &&
            id.length!==0 &&
            stuname.length!==0 &&
            session.length!==0 &&
            shift.length!==0 &&
            myclass.length!==0 &&
            period.length!==0 &&
            section.length!==0 
           
            
        ){
            setShow(true)
        }
        else{
        toast.error('Fill up the required fields', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }

        console.log(childData)
    }

    const handleInputSearch = (e)=>{
        setsearchkey(e.target.value)

    }
    const handleSearchButton=()=>{

    }
    const notification = {
        notification:true
    }

    const [childData, setChildData] = useState([
        {
            billAmount: '',
            receiveAmount: '',
            discount: '',
            period: '',
            remark: '',
            receiveType: '',
        },
        {
            billAmount: '',
            receiveAmount: '',
            discount: '',
            period: '',
            remark: '',
            receiveType: '',
        },
      ]);


      function validateUser(user) {
        const errors = [];
        if (!user.billAmount) {
            errors.push('Bill Amount is required');
        }else{
            
        }
        if (!user.receiveAmount) {
            errors.push('Receive Amount is required');
        }
        if (!user.discount) {
            errors.push('Discount is required');
        }
        if (!user.period) {
            errors.push('Period is required');
        }
        if (!user.remark) {
            errors.push('Remark is required');
        }
        if (!user.receiveType) {
            errors.push('Receive Type is required');
        }

        
        return errors;
    }

      const optionsreceivetype = [
        { id: 11, opt: 'cash' },
        { id: 22, opt: 'card' },
        // Add more options as needed
        ]
      const optionsperiod = [
        { id: 55, opt: 'Day' },
        { id: 56, opt: 'Morning' },
        // Add more options as needed
        ]
      const optionsremark = [
        { id: 55, opt: 'good' },
        { id: 56, opt: 'fantastic' },
        // Add more options as needed
        ]
    
      const handleInputChange = (index, field, value) => {
        const newData = [...childData];
        newData[index][field] = value;
        setChildData(newData);

       
      };

    
      const handledrprcvtype = (value, id, index) => {
        const newData = [...childData];
        newData[index]['receiveType'] = id;
        
        setChildData(newData);
      };
      const handledrpperiod = (value, id, index) => {
        const newData = [...childData];
        newData[index]['period'] = id;
        
        setChildData(newData);
      };
      const handledrpremark = (value, id, index) => {
        const newData = [...childData];
        newData[index]['remark'] = id;
        
        setChildData(newData);
      };

      const [show,setShow] = useState(false)
      function handleClose(){
        setShow(false)
      }
      const handlesaveMod1=()=>{
        setShow(false)

        // childData
      }

  return (
    <>
        <div className="f-flex flexvaluecomp">
            <SidebarOfAdash/>

            <div className="contentpartwidthwrapper" style={screenSize.dynamicHeight<925 ? {marginBottom:"75px"}:{}}>
                <div className="headerofadash billpart">
                <div className="left">
                    <div className="leftsidesearch">
                        <input type="text" value={searchkey} onChange={handleInputSearch} name="searchword" placeholder='Bill Number'/>
                        <span onClick={handleSearchButton}>
                            <img src="./assets/images/dashboards/adminDashboard/bill/searchbutton.png" alt="" />
                        </span>
                    <div className= {searchkey.length>0?"searchtable d-block":"searchtable d-none"}>
                    <div className="wrapper">

                        <div className="billentrytoptable searchtablediv">
                        <table>
                            <thead>
                            <tr>                                
                            {
                                searchtableApi.heading.map((item,key)=>{
                                    return(
                                        <th key={key}>{item.head}</th>
                                    )
                                })
                            }
                        </tr>
                            </thead>
                        <tbody>

                        {
                            searchtableApi.data.map((item,key)=>{
                                if(item.name.toLowerCase().includes(searchkey.toLowerCase())){

                                    return(
                                        <tr style={{cursor:"pointer"}} onClick={()=>handleRowClick(item)}>
                                            <td>{item.headerid}</td>
                                            <td>{item.id}</td>
                                            
                                             <HighlightRowText text={item.name} searchText={searchkey} />
                                            <td>{item.class}</td>
                                            <td>{item.section}</td>
                                            <td>{item.status}</td>
                                             
                                        </tr>
                                    )
                                }
                            })
                        }
                        </tbody>
                        </table>

                        </div>
                        </div>
                    </div>
                    </div>

                </div>
                <div className="right">
                    {
                        notification.notification==true?
                        <div className="belldiv">
                            <BiBell/>
                        </div>
                        :
                        <BiBell/>
                     }
                    <div className="displaypic">
                        <img src="./assets/images/dashboards/adminDashboard/header/DP.png" alt="" />
                    </div>
                    <div className="nameandid">
                        <h5>{adminHeaderApi.name}</h5>
                        <p>ID {adminHeaderApi.id}</p>
                    </div>
                </div>
            </div>

            <div className=" contentflexvalue billcontent billupdate w950">
                <Row>
                    <Col lg={12} className="pd15">  
                        <div className="smallheader d-flex">
                            <img src="./assets/images/dashboards/adminDashboard/bill/smheadinfo.png" alt="" />
                            <h4>Basic Information Bill</h4>
                        </div>
                                <div className="billbox small morph">
                   

                            <div className="threedivide">
                                <div className="commonthertythree">
                                        <div className="myrow h35">
                                        <div className="left">
                                            <p>Bill Number</p>
                                        </div>
                                        <div className="right">
                                            <div className="inputgap h35">
                                            <input type="text" style={borderbillnumber ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={billnumber} onChange={(e)=>setbillnumber(e.target.value)}/>
                                            <label>{labelbillnum}</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="myrow h35">
                                        <div className="left">
                                            <p>ID</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={borderid ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={id} onChange={(e)=>setid(e.target.value)}/>
                                            <label>{labelid}</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="myrow">
                                        <div className="left w130">
                                            <p>Student Name</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={borderstuname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={stuname} onChange={(e)=>setstuname(e.target.value)}/>
                                            <label>{labelstuname}</label>
                                        </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="threedivide">
                                <div className="commonthertythree">
                                        <div className="myrow">
                                        <div className="left">
                                            <p>Session</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={bordersession ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={session} onChange={(e)=>setsession(e.target.value)}/>
                                            <label>{labelsession}</label>
                                        </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="myrow">
                                        <div className="left">
                                            <p>Shift</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={bordershift ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={shift} onChange={(e)=>setshift(e.target.value)}/>
                                            <label>{labelshift}</label>
                                        </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="myrow">
                                        <div className="left w130">
                                            <p>Class</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={borderclass ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={myclass} onChange={(e)=>setclass(e.target.value)}/>
                                            <label>{labelclass}</label>
                                        </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="threedivide">
                                <div className="commonthertythree">
                                    <div className="myrow">
                                        <div className="left">
                                            <p>Period</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={borderperiod ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={period} onChange={(e)=>setperiod(e.target.value)}/>
                                            <label>{labelperiod}</label>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="commonthertythree">
                                    <div className="myrow">
                                        <div className="left">
                                            <p>Section</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={bordersection ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={section} onChange={(e)=>setsection(e.target.value)}/>
                                            <label>{labelsection}</label>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         
                                </div>
                      

                    
                    </Col>
                    <Col lg={12} className="pd15">  
                        <div className="smallheader d-flex">
                            <img src="./assets/images/dashboards/adminDashboard/bill/dtinfoicon.png" alt="" />
                            <h4>Detail Information Bill</h4>
                        </div>
                        <div className="wrapperwhite">
                        {/* //here */}
                        {childData.map((child, index) => (
                            <div key={index} className="billbox paymentcollectbox stuCommonformbox">
                            <div className="titlewithwhite">
                                <p>Child Information {index + 1}</p>
                            </div>
                            <Row>
                                {Object.keys(child).map((key, i) => (
                                <Col key={i} lg={4} className={ "pl5 pr5"}>                                    
                                    {
                                    key == 'receiveType' ? (
                                        <div className="basicinputfield h40p">
                                            <p>{key}</p>
                                        <div  className="inputgap h35p">
                                            <Dropdown2
                                                err={childData[index][`border${key}`]}
                                                func={(value, id) => handledrprcvtype(value, id, index)}
                                                myplaceholder="Select"
                                                fontsize="12"
                                                fontfamily="'Poppins', sans-serif"
                                                options={optionsreceivetype}

                                                />
                                                </div>

                                        </div>
                                    ) : 
                                    key == 'period' ? (
                                        <div className="basicinputfield h40p">
                                            <p>{key}</p>
                                        <div  className="inputgap h35p">
                                            <Dropdown2
                                                err={childData[index][`border${key}`]}
                                                func={(value, id) => handledrpperiod(value, id, index)}
                                                myplaceholder="Select"
                                                fontsize="12"
                                                fontfamily="'Poppins', sans-serif"
                                                options={optionsperiod}

                                                />
                                                </div>

                                        </div>
                                    ) : 
                                    key == 'remark' ? (
                                        <div className="basicinputfield h40p">
                                            <p>{key}</p>
                                        <div  className="inputgap h35p">
                                            <Dropdown2
                                                err={childData[index][`border${key}`]}
                                                func={(value, id) => handledrpremark(value, id, index)}
                                                myplaceholder="Select"
                                                fontsize="12"
                                                fontfamily="'Poppins', sans-serif"
                                                options={optionsremark}

                                                />
                                                </div>

                                        </div>
                                    ) : 
                                    
                                    (
                                    <div className="basicinputfield h35p">
                                        <p>{key.charAt(0).toUpperCase() + key.slice(1)}</p>
                                        <div className="inputgap h35">
                                        <input
                                            style={childData[index][`border${key}`] ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }}
                                            type="text"
                                            value={child[key]}
                                            onChange={(e) => handleInputChange(index, key, e.target.value)}
                                        />
                                       
                                        </div>
                                    </div>
                                    )
                                    
                                    }
                                </Col>
                                ))}
                            </Row>
                            </div>
                        ))}
                        
                        </div>
                      

                    
                    </Col>
                 
                </Row>

                <div className="bottombarofsave">
                    <div className="wrapper wrappertwo">
                    
                    
                    <button>Clear</button>
                    <button style={{background:"#65B36C"}} onClick={handleSave}>Update</button>
                    
                    </div>
                </div>
                <Modal style={{marginTop:"30vh"}} dialogClassName="mymodal" show={show} onHide={handleClose} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto"></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{textAlign:"center"}}>
                  <h3 style={{display:"inline-block",fontFamily:"'Poppins', sans-serif"}}>Are You Sure?</h3>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveMod1}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
              <ToastContainer
            
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            />
            </div>
            </div>
            </div>
    </>
  )
}

export default BillUpdateComp